module.exports = __webpack_public_path__ + "static/media/excel.89caf3fc.svg";